module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921011149_T.3382447e.jpg";